import { authApi } from '../api/authApi'

export const resendVerification = async (email: string) => {
  try {
    const response = await authApi.resendVerification(email)
    return response.data
  } catch (error) {
    console.error('Error requesting email verification', error)
    throw error
  }
}
